import { t } from '@avalara/bat-apps-shared/i18n';
import { SIcon } from '@avalara/skylab-sdk/react';

import styled from 'styled-components';
import BuyButton from '../buy-button';
import { FormContainer } from '../styled/forms';

const nextSteps = [
  'Check your email for an invoice',
  'Payment is due upon receipt of invoice',
  "After you pay, we'll finish setting up your account",
  'Then you can get started on your VAT registrations',
];

const DarkBlueIcon = styled(SIcon)`
  color: var(--color-accent-text);
`;

const Ioss = () => (
  <FormContainer>
    <h1>{t('client.headings.review-your-order')}</h1>
    <p>{t('client.general.you-re-all-set-to-purchase-avalara-import-one-stop-shop-solu')}</p>

    <p className='font-bold margin-top-sm'>{t('client.general.next-steps')}:</p>

    {nextSteps.map((step) => (
      <p key={`nextstep${step}`}>
        <DarkBlueIcon name='check' className='margin-right-sm' />
        {step}
      </p>
    ))}

    <p className='margin-top-md'>{t('client.general.recurring-charges-will-be-processed-with-the-payment-method')}</p>

    <BuyButton />
  </FormContainer>
);

export default Ioss;
